module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rechargePostUrl) ? _c('form', {
    staticClass: "setAttribute",
    attrs: {
      "name": "redirectpost",
      "method": "post",
      "action": _vm.rechargePostUrl,
      "target": "_blank"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "data"
    },
    domProps: {
      "value": _vm.xmlData
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "buy-btn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.rechargeSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('payNow')))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a4bb6f1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/recharge/RechargeByPost.vue
// module id = 371
// module chunks = 0